var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgConnections = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "connections",
    fillRule: "evenodd",
    d: "M13.5 7.5c0-.413-.336-.75-.75-.75s-.75.337-.75.75.336.75.75.75.75-.337.75-.75zm1.5 0c0 1.24-1.01 2.25-2.25 2.25S10.5 8.74 10.5 7.5s1.01-2.25 2.25-2.25S15 6.26 15 7.5zM8.25 5.25c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5.673 1.5 1.5 1.5 1.5-.673 1.5-1.5zm1.5 0c0 1.654-1.345 3-3 3-1.654 0-3-1.346-3-3 0-1.655 1.346-3 3-3 1.655 0 3 1.345 3 3zm.705 6.034c.652-.504 1.454-.784 2.295-.784 2.068 0 3.75 1.682 3.75 3.75 0 .414-.335.75-.75.75s-.75-.336-.75-.75c0-1.24-1.01-2.25-2.25-2.25-.512 0-.999.175-1.392.487.408.747.642 1.603.642 2.513 0 .414-.335.75-.75.75s-.75-.336-.75-.75c0-2.068-1.682-3.75-3.75-3.75S3 12.932 3 15c0 .414-.335.75-.75.75s-.75-.336-.75-.75c0-2.895 2.356-5.25 5.25-5.25 1.445 0 2.755.587 3.705 1.534z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConnections, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/connections.dac4cca5.svg";
export { ForwardRef as ReactComponent };